import { stopPoll } from '../../../../../db/polls';
import { Poll } from '../../../../../db/polls/types';
import { usePollContext } from '../../../Context';
import { getCanStopPoll } from '../../helpers';

const useStopPollAction = () => {
  const { poll, setPoll } = usePollContext();

  const canStopPoll = getCanStopPoll(poll);

  const handleStopPoll = async () => {
    if (!poll?.id) return;
    const { dueDateTime } = await stopPoll({ classId: poll.classId, pollId: poll.id });
    const updatedPoll: Poll = { ...poll, dueDateTime };
    setPoll(updatedPoll);
  };

  return { canStopPoll, handleStopPoll };
};

export default useStopPollAction;
